import * as S from './styles';

export type SkeletonProps = {
  width: number;
  height: number;
  borderRadius?: number;
  'data-testid'?: string;
};

const Skeleton = ({
  width,
  height,
  borderRadius = 4,
  'data-testid': dataTestId,
}: SkeletonProps) => (
  <S.Block
    $width={width}
    $height={height}
    $borderRadius={borderRadius}
    data-testid={dataTestId}
  />
);

export default Skeleton;
